var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-avatar"},[_c('img',{staticClass:"ui-avatar__img",attrs:{"src":require("@/assets/user-icon.jpg"),"alt":"User"}})])
}]

export { render, staticRenderFns }